export default __webpack_public_path__ + "static/media/olimpiad-school.7c5e7090.png";